import { Map, List } from 'immutable'
import { useDispatch } from 'react-redux'
import { getIdFromLocation } from '../../../services/content'
import { getApplicationDataByKey } from '../../../services/data'
import { setDataApplicationByKey } from '../../../services/data/redux/actions'

export function getDateWithoutTime (date) {
  if (date) {
    const resultArray = String(date).split('T')
    return resultArray[0]
  }
  return 0
}

/**
 * Get the application detail of the content for the detail page
 * @param {Object} props The props
 * @param {Map} props.data The redux data state
 * @param {Map} props.location The redux location state
 * @returns {Map} The application detail of content determined by the current path
 */
export const getCurrentContentDetail = (props) => {
  const { data, location, storeKey, applicationKey } = props
  const id = getIdFromLocation(location)
  const detail =
    getApplicationDataByKey({
      data,
      storeKey,
      applicationKey,
    }) || Map()
  return detail.get('id') === id ? detail : Map()
}

export const createOnChangeHandler = (props) => {
  const { storeKey, applicationKey } = props
  const dispatch = useDispatch()
  return function onChange (e) {
    const {
      target: { name, type, value, checked },
    } = e
    const content = getCurrentContentDetail(props)
    dispatch(
      setDataApplicationByKey({
        storeKey,
        applicationKey,
        applicationData: content
          .set(name, type === 'checkbox' ? checked : value)
          .map((x) => (x !== '' ? x : null)),
      }),
    )
  }
}

export const createFilteredDisplayChangeHandler = (props) => {
  const { storeKey, applicationKey } = props
  const dispatch = useDispatch()

  return (e) => {
    const {
      target: { value, checked },
    } = e

    const namePath = ['listCriteria', 'criteria', 'all']
    const content = getCurrentContentDetail(props)
    let all = content.getIn(namePath, List())

    const [contentType, productType] = value.split(',')
    const newValue = Map({
      contentType,
      ...(productType && { productType }),
    })

    if (checked) {
      all = all.push(newValue)
    } else {
      all = all.filter(
        (item) =>
          !(item.get('contentType') === contentType && item.get('productType') === productType),
      )
    }

    dispatch(
      setDataApplicationByKey({
        storeKey,
        applicationKey,
        applicationData: content.setIn(namePath, all),
      }),
    )
  }
}

export const getListCriteriaInitialValue = (content) => {
  const all = content.getIn(['listCriteria', 'criteria', 'all'])
  const result = []

  if (all) {
    all.forEach((item) => {
      const contentType = item.get('contentType')
      const productType = item.get('productType')
      const newItem = { contentType }
      if (productType) {
        newItem.productType = productType
      }
      result.push(newItem)
    })
  }

  return {
    criteria: {
      all: result,
    },
  }
}
